import { Title, View } from './DefaultError'

const Errors = {
    DefaultError: {
        Title,
        View,
    },
}

export default Errors
